module.exports = __webpack_public_path__ + "img/alb-sanitario.90f3a8fe.jpg";